import React, { useEffect, useState } from 'react'
import InputField from '../../../ReusableComponents/InputField'
import DatePickerField from '../../../ReusableComponents/DatePickerField'
import Modal from '../../../ReusableComponents/Modal'
import Form from '../../../ReusableComponents/Form'
import { Button } from '../../../Components/Helper'
import Loading from '../../../ReusableFunctions/Loader'
import Popup from '../../../ReusableFunctions/Popup'
import { getDspSettlementInvoiceDetails, settleDspInvoice } from '../../../apis/adminAPIs/finance/dspInvoices'
import { BankAccountNoValidation, UTRValidation, bankNameValidation, nameValidation, selectFieldValidation } from '../../../utils/inputValidations'
import { SETTELEMENT_STATUSES } from '../../../appConstants'

const SettlmentForm = ({ invoice, open, onClose, onUpdate, toBankDetails }) => {
    const [settInvoice, setSettInvoice] = useState({})

    const getSettelementInvoiceDetailsFunc = async () => {
        try {
            Loading.set(true)
            const settleInvoice = await getDspSettlementInvoiceDetails(invoice?.id)
            setSettInvoice({
                ...settleInvoice,
                ...invoice,
                time: new Date(settleInvoice?.time),
                invoice_id: invoice?.id,
                generated_time: new Date(settleInvoice?.generated_time)
            })
            Loading.set(false)
        } catch (error) {
            Loading.set(false)
            Popup.alert("Error", error, "ERROR")
        }
    }

    const handleInvoiceSettlement = async (invoice) => {
        try {
            Loading.set(true)
            await settleDspInvoice(invoice)
            onUpdate({ ...invoice, status: SETTELEMENT_STATUSES.SETTELED })
            Loading.set(false)
            Popup.alert("Success", "Invoice settled successfully!", "SUCCESS");
        } catch (error) {
            Loading.set(false)
            Popup.alert("Error", error, "ERROR")
        }
    }

    useEffect(() => {
        getSettelementInvoiceDetailsFunc()
    }, [])

    return (
        <Modal
            header={invoice?.status === "unsettled" ? "Mark As Paid" : "Settlled Transaction"}
            open={open}
            onClose={onClose}
            contentStyle={{ width: "640px", height: "auto", borderRadius: "10px" }}
            headerContainerStyle={{ padding: "25px 30px", }}
        >
            <Form
                onSubmitForm={(invoice) => {
                    handleInvoiceSettlement(invoice)
                }}
                initialValues={settInvoice}
            >
                {(onSubmit) => (
                    <div className="addDrone_form_wrapper" >
                        <div className="add_drone_form" style={{ padding: "10px 30px" }}>
                            <InputField
                                label={"Transaction Id"}
                                type={"text"}
                                id={"transaction_id"}
                                name={"transaction_id"}
                                placeholder={"Please Enter Transaction Id"}
                                containerStyle={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    minHeight: "80px",
                                }}
                                disabled={settInvoice?.status === SETTELEMENT_STATUSES.SETTELED}
                                validation={selectFieldValidation}
                            />
                            {/* <InputField
                                label={"Bank Name"}
                                type={"text"}
                                id={"from_bank_account_name"}
                                placeholder={"Please Enter Bank Name"}
                                name={"from_bank_account_name"}
                                containerStyle={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    minHeight: "80px",
                                }}
                                disabled={settInvoice?.status === SETTELEMENT_STATUSES.SETTELED}
                                // validation={bankNameValidation}
                            />
                            <InputField
                                label={"Account No."}
                                type={"text"}
                                id={"from_bank_account_number"}
                                placeholder={"Please Enter Account No."}
                                name={"from_bank_account_number"}
                                containerStyle={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    minHeight: "80px",
                                }}
                                disabled={settInvoice?.status === SETTELEMENT_STATUSES.SETTELED}
                                // validation={BankAccountNoValidation}
                            /> */}
                            {/* <InputField
                                label={"UTR"}
                                type={"text"}
                                id={"utr"}
                                placeholder={"Please Enter UTR"}
                                name={"utr"}
                                containerStyle={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    minHeight: "80px",
                                }}
                                disabled={settInvoice?.status === SETTELEMENT_STATUSES.SETTELED}
                                validation={UTRValidation}
                            /> */}
                            {/* <div style={{ width: "250px" }}>
                                <DatePickerField
                                    label={"Time"}
                                    name={"time"}
                                    readOnly={settInvoice?.status === SETTELEMENT_STATUSES.SETTELED}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={1}
                                    dateFormat="h:mm aa"
                                />
                            </div> */}
                            <InputField
                                label={"Mode"}
                                type={"text"}
                                id={"mode"}
                                placeholder={"Please Enter Mode"}
                                name={"mode"}
                                containerStyle={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    minHeight: "80px",
                                }}
                                disabled={settInvoice?.status === SETTELEMENT_STATUSES.SETTELED}
                                validation={selectFieldValidation}
                            />
                            <InputField
                                label={"Note"}
                                type={"text"}
                                id={"note"}
                                placeholder={"Please Enter Note"}
                                name={"note"}
                                containerStyle={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    minHeight: "80px",
                                }}
                                disabled={settInvoice?.status === SETTELEMENT_STATUSES.SETTELED}
                            />
                        </div>
                        {(settInvoice?.status !== SETTELEMENT_STATUSES.SETTELED || !toBankDetails?.id) &&
                            <div className="buttons_wrapper" style={{ padding: "10px 30px" }}>
                                <Button
                                    className={"btn-large"}
                                    text={"Done"}
                                    onClick={onSubmit}
                                    style={{ width: "100px" }}
                                />
                                <Button
                                    className={"btn-large lg-cancel-btn "}
                                    text={"Cancel"}
                                    onClick={onClose}
                                    isBtnNotActive={true}
                                />
                            </div>
                        }
                    </div>
                )}
            </Form>
        </Modal>
    )
}

export default SettlmentForm